exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".non-resizeable[data-v-1898fbce] {\n  resize: none;\n}\n.reports-frame-style[data-v-1898fbce] {\n  height: 75vh;\n  width: 100%;\n  border: 1px solid grey;\n  border-radius: 7px;\n}\n", ""]);

// exports
